import React, { Component } from 'react';
import {
  CallToActionBlock,
  ServicesBlock,
  FeaturedStoriesBlock,
  StoryPortraitPhoto,
  StoryLandscapePhoto,
  StorySquarePhoto,
  StoryPortraitPair,
  StoryLandscapePair,
  StorySquarePair,
} from './Slices';

const CALL_TO_ACTION_BLOCK_TYPE = 'call_to_action_block';
const SERVICE_BLOCK_TYPE = 'services_block';
const FEATURED_STORIES_BLOCK_TYPE = 'featured_stories_block';
const STORY_PORTRAIT_PHOTO_TYPE = 'portrait_photo';
const STORY_LANDSCAPE_PHOTO_TYPE = 'landscape_photo';
const STORY_SQUARE_PHOTO_TYPE = 'square_photo';
const STORY_PORTRAIT_PAIR_TYPE = 'portrait_pair';
const STORY_LANDSCAPE_PAIR_TYPE = 'landscape_pair';
const STORY_SQUARE_PAIR_TYPE = 'square_pair';

export default class SliceZone extends Component {
  render() {
    const { allSlices, siteMetadata } = this.props;
    const slice = allSlices && allSlices.map((s) => {
      switch (s.slice_type) {
        // These are the API IDs of the slices
        case CALL_TO_ACTION_BLOCK_TYPE:
          return <CallToActionBlock key={s.id} input={s} siteMetadata={siteMetadata} />;
        case SERVICE_BLOCK_TYPE:
          return <ServicesBlock key={s.id} input={s} siteMetadata={siteMetadata} />;
        case FEATURED_STORIES_BLOCK_TYPE:
          return <FeaturedStoriesBlock key={s.id} input={s} siteMetadata={siteMetadata} />;
        case STORY_PORTRAIT_PHOTO_TYPE:
          return <StoryPortraitPhoto key={s.id} input={s} siteMetadata={siteMetadata} />;
        case STORY_LANDSCAPE_PHOTO_TYPE:
          return <StoryLandscapePhoto key={s.id} input={s} siteMetadata={siteMetadata} />;
        case STORY_SQUARE_PHOTO_TYPE:
          return <StorySquarePhoto key={s.id} input={s} siteMetadata={siteMetadata} />;
        case STORY_PORTRAIT_PAIR_TYPE:
          return <StoryPortraitPair key={s.id} input={s} siteMetadata={siteMetadata} />;
        case STORY_LANDSCAPE_PAIR_TYPE:
          return <StoryLandscapePair key={s.id} input={s} siteMetadata={siteMetadata} />;
        case STORY_SQUARE_PAIR_TYPE:
          return <StorySquarePair key={s.id} input={s} siteMetadata={siteMetadata} />;
        default:
          return null;
      }
    });
    return <>{slice}</>;
  }
}
